export default "__VITE_ASSET__Bd4ql5yq__"